import { AfterViewInit, ChangeDetectorRef, Component, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelect } from '@angular/material/select';
import { RxFormBuilder, RxwebValidators } from '@rxweb/reactive-form-validators';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { OpportunityManagementService } from 'src/app/modules/admin/opportunity-management/opportunity-management.service';
import { SaleOpportunityViewModel } from 'src/app/modules/admin/opportunity-management/opportunity.model';
import { AutomateDataState } from 'src/app/modules/admin/profile-management/profile-detail/automate-datastate-log/automate-datastate-model';
import { AutomateDatastateService } from 'src/app/modules/admin/profile-management/profile-detail/automate-datastate-log/automate-datastate.service';
import { TblActionType } from 'src/app/shared/enums/tbl-action-type.enum';
import { map, take, takeUntil } from 'rxjs/operators';
import { NbToastrService } from '@nebular/theme';
import { Helper } from 'src/app/shared/utility/Helper';
import { ConfirmModalComponent } from '../../confirm-modal/confirm-modal.component';
import { DynamicContentService } from 'src/app/shared/services/dynamic-content.service';
import { SettingService } from 'src/app/shared/services/setting.service';
import { environment } from 'src/environments/environment';
import { MicrosoftOffice365Service } from 'src/app/shared/services/microsoft-office-365.service';
import { ReturnResult } from 'src/app/shared/models/return-result';

@Component({
  selector: 'app-opportunity-modal',
  templateUrl: './opportunity-modal.component.html',
  styleUrls: ['./opportunity-modal.component.scss']
})
export class OpportunityModalComponent implements OnInit, AfterViewInit {
  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;
  @Input() saleAccountId: string;
  @Input() actionType: TblActionType = TblActionType.Add;
  @Input() saleOpportunityViewModel: SaleOpportunityViewModel;

  protected _onDestroy = new Subject<void>();

  environment = environment;
  opportunityForm: FormGroup;
  // loading for entire modal
  modelLoading: boolean = false;
  loading = false;
  automateDataStateList: AutomateDataState[] = [];
  automateCtrl: FormControl = new FormControl();
  automateFilterCtrl: FormControl = new FormControl();
  filteredAutomate: ReplaySubject<AutomateDataState[]> = new ReplaySubject<AutomateDataState[]>(1);
  isChange: boolean = false;
  leadSourceDynamicAPI;
  typeDynamicAPI;
  companyDynamicAPI;
  leadSourceLoading = false;
  typeLoading = false;
  companyLoading = false;
  solutionLoading = false;
  marketLoading = false;

  listMarketAPI: Observable<ReturnResult<{content: string}[]>>;
  listSolutionAPI: Observable<ReturnResult<{content: string}[]>>;
  marketList: string[] = [];
  solutionList: string[] = [];
  validProperties = {
    market: {
      valid: [this.inArrayValidator("MARKET")],
      message: "Market is not valid"
    },
    solution: {
      valid: [this.inArrayValidator("SOLUTION")],
      message: "Solution is not valid"
    }
  }

  stateWon: string;
  stateClose: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private frmBuilder: RxFormBuilder,
    private service: OpportunityManagementService,
    private automateDataStateService: AutomateDatastateService,
    private dialModalRef: MatDialogRef<OpportunityModalComponent>,
    private toastService: NbToastrService,
    private dialog: MatDialog,
    private dynamicContentService: DynamicContentService,
    private cdref: ChangeDetectorRef,
    private settingService: SettingService,
    private microsoftOffice365Service: MicrosoftOffice365Service
  ) {
    // Transform string arrays to object arrays for primas-auto-complete compatibility
    this.listMarketAPI = this.service.getMarketList().pipe(
      map(res => ({
        ...res,
        result: res.result.map(item => ({ content: item }))
      }))
    );
    this.listSolutionAPI = this.service.getSolutionList().pipe(
      map(res => ({
        ...res,
        result: res.result.map(item => ({ content: item }))
      }))
    );
    this.service.getMarketList().subscribe(res => this.marketList = res.result);
    this.service.getSolutionList().subscribe(res => this.solutionList = res.result);

    this.leadSourceDynamicAPI = this.dynamicContentService.getDynamicContentByType('opportunity-source');
    this.typeDynamicAPI = this.dynamicContentService.getDynamicContentByType('opportunity-type');
    this.companyDynamicAPI = this.dynamicContentService.getDynamicContentByType('general_company');
    this.actionType = data.actionType ?? this.actionType;
    this.saleAccountId = data.saleAccountId ?? this.saleAccountId;
    this.modelLoading = true;

    if (data.model) {
      this.saleOpportunityViewModel = data.model;
    } else {
      this.saleOpportunityViewModel = new SaleOpportunityViewModel();
    }
    this.saleOpportunityViewModel.saleAccountId = this.saleAccountId;

    if (this.actionType == TblActionType.Add) {
      this.saleOpportunityViewModel.saleAccountId = this.saleAccountId;

      //THIS IS A LOGIC FROM SALE_ACCOUNT DETAIL
      //Auto populate Account name as a Company Name
      if (this.data && this.data.companyName) {
        this.saleOpportunityViewModel.company = this.data.companyName
      }

    } else if (this.actionType == TblActionType.Edit) {
      // parse date from backend
      if (this.saleOpportunityViewModel.closeDate && Helper.isDateString(this.saleOpportunityViewModel.closeDate.toString()))
        this.saleOpportunityViewModel.closeDate = new Date(this.saleOpportunityViewModel.closeDate);
      if (this.saleOpportunityViewModel.secondaryCloseDate && Helper.isDateString(this.saleOpportunityViewModel.secondaryCloseDate.toString()))
        this.saleOpportunityViewModel.secondaryCloseDate = new Date(this.saleOpportunityViewModel.secondaryCloseDate);
    }

  }

  ngOnInit() {
    this.automateDataStateService.getDataStateList().subscribe(data => {
      this.automateDataStateList = data;
      if (this.automateDataStateList && this.automateDataStateList.length > 0) {
        this.initSearchAutomateDataState();
        this.changeValue(false);
      }
    });
    this.opportunityForm = this.frmBuilder.formGroup(SaleOpportunityViewModel, this.saleOpportunityViewModel);
    if (this.opportunityForm.controls.type) {
      this.opportunityForm.controls.type.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(val => {
        this.changeValue(false);
      });
    }
    this.setupState();

    // get required for stageId:
    this.opportunityForm.controls.stageId.setValidators([RxwebValidators.required()]);
    this.opportunityForm.controls.market.setValidators(this.validProperties.market.valid);
    this.opportunityForm.controls.solution.setValidators(this.validProperties.solution.valid);
    // this.opportunityForm.controls.closeDate.setValidators([RxwebValidators.pattern({ expression: { 'pattern': /^\d{2}\/\d{2}\/\d{4}$/ }, message: 'Please enter valid format: DD/MM/YYYY ' })]);
  }

  ngAfterViewInit(): void {
    if (this.opportunityForm) {
      this.opportunityForm.valueChanges.pipe(take(1))
        .subscribe(resp => this.isChange = true);
    }
    this.cdref.detectChanges();
  }

  async setupState() {
    var res = await this.settingService.getSettingByGroupName("SALE_CONFIG").toPromise();
    if (res.result) {
      this.stateWon = res.result.find(x => x.key == "WON_TYPE_ID")?.value || '';
      this.stateClose = res.result.find(x => x.key == "LOST_TYPE_ID")?.value || '';
    }

    this.automateDataStateService.refreshAllAutomateDataState((data) => this.modelLoading = data);
  }

  closeDialog(res: boolean = false) {
    if (this.isChange) {
      this.isChange = false;
      const dialogRef = this.dialog.open(ConfirmModalComponent, {
        data: {
          message: "Do you wish to close this popup? You will lose your unsaved data."
        }
      });

      dialogRef.afterClosed().subscribe(response => {
        if (response) this.dialModalRef.close();
        else this.isChange = true;
      });
      return;
    }

    this.dialModalRef.close(res);
  }

  initSearchAutomateDataState() {
    // if in edit mode:
    if (this.actionType === TblActionType.Edit && this.saleOpportunityViewModel.stageId) {
      // map stageId to select dropdown:
      var stageId = this.saleOpportunityViewModel.stageId;
      var currentStage = this.automateDataStateList.find(v => v.automateDataStateId === stageId);
      if (currentStage) {
        this.automateCtrl.setValue(currentStage);
      }
    } else if (this.actionType === TblActionType.Add && this.automateDataStateList.length > 0) {
      let firstAutoData = this.automateDataStateList[0];
      this.saleOpportunityViewModel.stageId = firstAutoData.automateDataStateId;
      this.automateCtrl.setValue(firstAutoData);
    }
    // load the initial bank list
    this.filteredAutomate.next(this.automateDataStateList.slice());
    // listen for search field value changes
    this.automateFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterAutomateDataState();
      });
  }
  protected filterAutomateDataState() {
    if (!this.automateDataStateList) {
      return;
    }
    // get the search keyword
    let search = this.automateFilterCtrl.value;
    if (!search) {
      this.filteredAutomate.next(this.automateDataStateList.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredAutomate.next(
      this.automateDataStateList.filter(x => x.dataStateName.toLowerCase().indexOf(search) > -1)
    );
  }
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
  changeValue(data) {
    if (!data) {
      // this.selectionChange.emit(this.bankCtrl.value);
      if (this.opportunityForm?.controls && this.automateCtrl?.value && this.automateCtrl?.value?.automateDataStateId) {
        let stageId = this.automateCtrl.value.automateDataStateId.toString();
        let typeVal = this.opportunityForm.controls.type?.value;
        this.opportunityForm.controls.stageId.setValue(stageId);

        if (stageId === this.stateWon && stageId !== this.stateClose) {
            this.opportunityForm.controls.probability.setValue(100);
            this.opportunityForm.controls.probability.disable();
        } else if (stageId === this.stateClose && stageId !== this.stateWon) {
            this.opportunityForm.controls.probability.setValue(0);
            this.opportunityForm.controls.probability.disable();
        } else if (stageId === this.stateWon && stageId === this.stateClose) {
            if (typeVal === 'WON') {
                this.opportunityForm.controls.probability.setValue(100);
                this.opportunityForm.controls.probability.disable();
            } else if (typeVal === 'LOST') {
                this.opportunityForm.controls.probability.setValue(0);
                this.opportunityForm.controls.probability.disable();
            } else {
                this.opportunityForm.controls.probability.enable();
            }
        } else {
            this.opportunityForm.controls.probability.enable();
        }
      }
    }
  }

  async onClickSave() {
    if (!this.opportunityForm.valid) {
      this.toastService.warning('Please enter all required fields', 'Warning');
      return;
    }
    
    this.loading = true;
    this.opportunityForm.enable();
    
    try {
      var newOp: SaleOpportunityViewModel = this.opportunityForm.value;
      var oldOp: SaleOpportunityViewModel = this.saleOpportunityViewModel;
      newOp.saleAccountId = this.saleAccountId;
      newOp.referenceId = this.saleAccountId;
      
      const result = await this.service.SaveAccountOpportunity(newOp).toPromise();
      
      // Handle folder name update if opportunity name changed
      if (newOp && oldOp && newOp.opportunityName != oldOp.opportunityName && oldOp.opportunityProfile) {
        try {
          await this.microsoftOffice365Service.updateNameFolder(
            oldOp.opportunityProfile.profileId,
            oldOp.opportunityProfile.typeName,
            oldOp.opportunityName, 
            newOp.opportunityName
          ).toPromise();
        } catch (folderError) {
          console.error('Error updating folder name:', folderError);
          // Continue with success flow even if folder update fails
        }
      }

      if (this.actionType === TblActionType.Add) {
        await this.openOneDriveFolderUrl(result.result);
      }

      if (result.result) {
        this.toastService.success(`${this.actionType == TblActionType.Add ? 'Create' : 'Edit'} new ${this.environment.titleOpportunity} successfully`, 'Success');
      }
    } catch (error) {
      console.error('Error saving opportunity:', error);
      // Handle error if needed
    } finally {
      this.loading = false;
      this.isChange = false;
      this.closeDialog(true);
    }
  }

  async openOneDriveFolderUrl(createOpportunityId: string) {
    try {
      await this.microsoftOffice365Service.getOneDriveFolderData(createOpportunityId, 'OPPORTUNITY').toPromise();
    } catch (error) {
      console.log(error);
    }
  }

  onNumberFocus(controlName: string) {
    let value = this.opportunityForm.controls[controlName].value;
    if (!isNaN(value) && value == 0) {
      this.opportunityForm.controls[controlName].setValue(undefined);
      this.opportunityForm.controls[controlName].markAsTouched();
    }
  }
  onNumberUnFocus(controlName: string) {
    let value = this.opportunityForm.controls[controlName].value;
    if (!value || value == "") {
      this.opportunityForm.controls[controlName].setValue(0);
    }
  }
  getLoadingValueLeadSource(value: boolean) {
    this.leadSourceLoading = value;
  }
  getLoadingValueType(value: boolean) {
    this.typeLoading = value;
  }
  getLoadingValueCompany(value: boolean) {
    this.companyLoading = value;
  }
  getLoadingValueSolution(value: boolean) {
    this.solutionLoading = value;
  }
  getLoadingValueMarket(value: boolean) {
    this.marketLoading = value;
  }
  resetSecondaryValue() {
    event.stopPropagation();
    this.opportunityForm.controls['secondaryCloseDate'].setValue(null);
  }

  resetCloseDate() {
    event.stopPropagation();
    this.opportunityForm.controls['closeDate'].setValue(null);
  }

  private inArrayValidator(type: string) {
      return (control: FormControl) => {
        // Sử dụng danh sách đã được tải trong component
        let defaultArray: string[] = [];
        switch (type) {
          case "MARKET":
            defaultArray = this.marketList;
            break;
          case "SOLUTION":
            defaultArray = this.solutionList;
            break;
        }
  
        const value = control.value;
        if (!value || defaultArray.includes(value) || Helper.isNullOrEmpty(value)) {
          return null; // Value is valid
        } else {
          return { inArray: true }; // Value is invalid
        }
      };
    }
}
